/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyZoomIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-zoom" */ './utils').then((m) => m.ZoomIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/zoom/icon' },
);

const LazyZoomSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-zoom-search-result" */ './utils').then(
			(m) => m.ZoomSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/zoom/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ZoomIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyZoomIconComponent />
	</Suspense>
);

export const ZoomSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyZoomSearchResultIconComponent />
	</Suspense>
);
